export const generatedCandidateSourceReviewDocket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-30T00:00:00.000Z",
  "mode": "deterministic-candidate-source-review-docket",
  "operatingRule": "This docket is a reviewer worklist for source custody only. It cannot promote resource composition, customer use, or scenario conclusions without candidate-specific composition evidence and source-use clearance.",
  "asteroidCandidateEvidenceLedgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
  "candidateSourcePromotionLedgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
  "candidateSourceClosurePacketHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
  "candidateSourceWorkOrderCount": 10,
  "reviewItemCount": 10,
  "sourceCustodyReadyCount": 0,
  "resourceReadyCount": 0,
  "customerReadyCount": 0,
  "draftIntakeCount": 10,
  "noIntakeCount": 0,
  "reviewLaneCounts": {
    "draft-source-custody-review": 10
  },
  "reviewState": "blocked-source-custody-review-worklist",
  "reviewItems": [
    {
      "id": "candidate-source-review-2026-jm2",
      "workOrderId": "small-body-source-work-order-2026-jm2",
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "queueRank": 1,
      "reviewPriorityScore": 52.39,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-27ed506353fa24d5431635d512ed55cb2d204b51825c36d957d03a8494edbe63"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-2a3ef27520e303a54a66a34c836def37d75ea79a461eb3a8a9abd5b1850eb14c"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-85b1deb6c916e108b317a6ca2405617c2f6b9d752c9c2202dc30b32f7c64bb4c"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-b8c9884921e96895d07fd3d092019180bf1216464d394737fc23d9ae2d95fa08",
      "reviewItemHash": "sha256-dcd3c55edbea6318bed1aa37c4db9b69c4ca0de6a6accb17d4120b05f85cee5a"
    },
    {
      "id": "candidate-source-review-2026-em",
      "workOrderId": "small-body-source-work-order-2026-em",
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "queueRank": 2,
      "reviewPriorityScore": 44.28,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-8fa7d9008b5a7837c04c6fec992be3caa2fa11b38592f6d7f351afadae1d3c9e"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-c98de17107649e4f49f61200ec32e76562a3084e0d325b30510244c68c90b4b7"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-641a96ebaba165d05af9298890558bb4085b38f30e739fb84b582d1a9c39785e"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-5fe6fb4a6dbb2dab31c843b41f2f8ea0bf38970f6b37602b3057f57ec166f476",
      "reviewItemHash": "sha256-d85476ed015912a666b3bce21b13be38e38d5519c832a1cc3234901e31ed28e7"
    },
    {
      "id": "candidate-source-review-2026-dn5",
      "workOrderId": "small-body-source-work-order-2026-dn5",
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "queueRank": 3,
      "reviewPriorityScore": 39.5,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-b61f18a3e0de39e173cb0198832f78de8eec280557ef4fd9142ad55d182277cf"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-90d677de7decc07ae526b7fd89e72ccac8ea2b183f1d018a0f183c9c80249392"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-27e7bb81f1c4d022e92bfd382905dd753e4ea9c5ed2fd397e0b97562ee375f47"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-1f658a0d55749a22f8502fb8da9afc75587853bf55d17d44a1b27c8f151ad35e",
      "reviewItemHash": "sha256-ab2ce51782210784c3d21f58cc689bbf41a945a06c1a383189b36879ef51a0d6"
    },
    {
      "id": "candidate-source-review-2026-lx",
      "workOrderId": "small-body-source-work-order-2026-lx",
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "queueRank": 4,
      "reviewPriorityScore": 39.44,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-dacf600fd5410f655e246f540fa78602b373b226d92ace772ae8b06eb9aabecf"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-791c15b182a44058b0bd6a6f9bff78f5796724679fbbbf4a0a1fb04fc80c25d2"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-43977f73714168c73c6eb4b6c769f8d3b5db0ebadb4941ddc51b36afb347c7f5"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-8e023ddbb1663a7f0a13db2d79d2d8a9778517c2ca417d97068361e34ae4b171",
      "reviewItemHash": "sha256-df1e553c8410289048f9e55e0ff5adbb6f9ff35afb5a4770cdb38f7bbe740f0d"
    },
    {
      "id": "candidate-source-review-2026-ku1",
      "workOrderId": "small-body-source-work-order-2026-ku1",
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "queueRank": 5,
      "reviewPriorityScore": 36.59,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-c2e4c4d4248ab20ec8644ff79ad7ac1d64e0b92fb7a3efa3063559caabf5f610"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-acfde7a49e395ff0be48794e2b2ddac86098e3ab74cebe0250cc4779a08dc639"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-482e7e2e661bee68b01559f1590d08e752455ae900336262f0811b1bee82286b"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-a717d87ca9fe0b2d21044b443a4a2c75b8f858a4dac5746506dc16d78074e4a0",
      "reviewItemHash": "sha256-aa5afe05c3d1c16520bddb12d93bec61c6bd438f997515ee47050b3ebd86a294"
    },
    {
      "id": "candidate-source-review-2026-fs5",
      "workOrderId": "small-body-source-work-order-2026-fs5",
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "queueRank": 6,
      "reviewPriorityScore": 30.19,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-820ada4336a2f59c4b5158388e70a8bd16e66f14c6e2fe5467cf6a948307f64b"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-0ed2f45d6f34fb58d626b10e94737add155f70628356638e8b422c9316c39cd2"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-0463eea4ab6511dc755137855a34291943e7ba9753397c0eef74878aa0865cdf"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-59f5b1dbd44428ab2fc9136eb918bf832aa498d1720e7caebc2e6724044512c5",
      "reviewItemHash": "sha256-c57d561cd4a135bf0d8d5af7aae534aef670899266f4d6ef539e0c6932785f51"
    },
    {
      "id": "candidate-source-review-2026-et3",
      "workOrderId": "small-body-source-work-order-2026-et3",
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "queueRank": 7,
      "reviewPriorityScore": 25.97,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-96db53717bea6d2a65f6663b5c0559776e5a46bdddaca7823a45e2bc6ca2b129"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-7e13e4699144544dde5babb4d781307442cf89bf58ff4b56a92b9712d6f70d81"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-6ecfcbd8a53e323cfc45f68b85ed73d2b05fbbe3b4fad478797fcedf04bd2d62"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-09986b83f9409f52af4e880c7fc9936888f8c4817dc3fe7cf1ea163c5f09b44a",
      "reviewItemHash": "sha256-0d99708d7c3537e869c80e9dc30d07f191e0219e09989a227b91fb007c3d5a2e"
    },
    {
      "id": "candidate-source-review-2026-jn4",
      "workOrderId": "small-body-source-work-order-2026-jn4",
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "queueRank": 8,
      "reviewPriorityScore": 24.65,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-31de9f397bb073a33f8d4b4aa0e768bae140151c150c3e3af4ceaf4fd5d91c55"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-06be77dc860069bacc706cd2b0db0e76107bcb3e8a04e246330db5b86919c8e1"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-a83632d1c700dcf27543133254a93370d6f58db6f3b77b55843a61e535d0a17f"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-7701b57f3dbc66ab0ca0f2b87dfff4a7e20bcac6046c973d6a3eeaf395725c0d",
      "reviewItemHash": "sha256-8101b46b54051d5a7671737bfce82979b28a68a217d497e8d4263d03cd231325"
    },
    {
      "id": "candidate-source-review-2026-jv3",
      "workOrderId": "small-body-source-work-order-2026-jv3",
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "queueRank": 9,
      "reviewPriorityScore": 24.51,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-adc2d4bb966b9b0c0d58b30bc6b816bd33b7101ee23795cd9e2c231d1fa7f471"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-ce2c11338294b9b91f867a42b8c1f34626e36279299eb01c31ead46303bcdc63"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-9737fc01a428f99b0647339ef57e60ac65e607c2a72170eb7bd4f5f2a0cdbe0c"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-2dc111105cac0e4a2eadba7e79694dced3819549bfbda8fdbdbeeaba97567d89",
      "reviewItemHash": "sha256-f9384c44f5c3f22eefda8d7c303a343442a14f6e9a555e62e999f360c25542c8"
    },
    {
      "id": "candidate-source-review-2026-hz4",
      "workOrderId": "small-body-source-work-order-2026-hz4",
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "queueRank": 10,
      "reviewPriorityScore": 24.43,
      "reviewLane": "draft-source-custody-review",
      "intakeState": "draft-intake-present-fail-closed",
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "querySourceGaps": [
        "mpc"
      ],
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "nextAction": "Close MPC bridge, source-use review, reviewer approval, and validation-status gates for the existing draft packet.",
      "requiredClosureItemCount": 6,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "title": "Attach MPC observation/designation bridge receipt",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-6a6f08776849331472639a78707dd66fe6c339f78dbd498851e1ee31d2170563"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "title": "Approve source license and terms review",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-68b3cf18ae6cd24aec6b75036a2322686006d7d8cbe2a3fd4e038b67d1cb325f"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "title": "Approve candidate source review",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-ddb162a08a78431de5374af929a2f430902115fb619f85fb7eb8cee1a2a97a9c"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "title": "Set validation status to passed only after evidence closure",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "title": "Attach candidate-specific composition evidence",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "title": "Approve customer/report source-use clearance",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "commandSequence": [
        "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-fb5bb6e981af93caaf4fdcfad689868e211b41f5a804eec318002b4dc3135010",
      "reviewItemHash": "sha256-a6bb0383ee23461517ddbcf7ca0a533296ad0c26cbcbfd849f2f12c3f7cca645"
    }
  ],
  "docketHash": "sha256-a3b7bbb0c2d6ec7f65631fdb06e8adeee86a700278b198f83673171bf8196977"
}
;
